import Swal from "sweetalert2";

export default function errormessage(message) {
    return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,
    })  
}
